import React from 'react';
import { useMap } from 'react-leaflet';
import { useTranslation } from '../i18n/useTranslation.js';

interface MapControlsProps {
  onResetView: () => void;
  perimsOn: boolean;
  onTogglePerims: () => void;
}

function MapControls({ onResetView, perimsOn, onTogglePerims }: MapControlsProps) {
  const { t } = useTranslation();
  const map = useMap();

  return (
    <div className="map-ctrls">
      <button className="mcb" onClick={() => map.zoomIn()} title={t('mapOverlays.zoomIn')}>
        +
      </button>
      <button className="mcb" onClick={() => map.zoomOut()} title={t('mapOverlays.zoomOut')}>
        −
      </button>
      <button className="mcb" onClick={onResetView} title={t('mapOverlays.resetView')}>
        ⌖
      </button>
      <button
        className={`mcb ${perimsOn ? 'on' : ''}`}
        onClick={onTogglePerims}
        title={t('mapOverlays.togglePerimeters')}
      >
        ◎
      </button>
    </div>
  );
}

interface MapFiltersProps {
  filters: { highThreat: boolean; protected: boolean; flagged: boolean; trails: boolean; protectedUsers: boolean };
  onToggleFilter: (key: string) => void;
  showTrails: boolean;
}

function MapFilters({ filters, onToggleFilter, showTrails }: MapFiltersProps) {
  const { t } = useTranslation();
  return (
    <div className="map-filters">
      <div className={`mfc ar ${filters.highThreat ? 'on' : ''}`} onClick={() => onToggleFilter('highThreat')}>
        <span className="cd r" />
        {t('mapOverlays.highThreat')}
      </div>
      <div className={`mfc ag ${filters.protected ? 'on' : ''}`} onClick={() => onToggleFilter('protected')}>
        <span className="cd g" />
        {t('mapOverlays.protectedZones')}
      </div>
      <div className={`mfc ab ${filters.flagged ? 'on' : ''}`} onClick={() => onToggleFilter('flagged')}>
        <span className="cd b" />
        {t('mapOverlays.flagged')}
      </div>
      <div className={`mfc apu ${filters.protectedUsers ? 'on' : ''}`} onClick={() => onToggleFilter('protectedUsers')}>
        <span className="cd pu" />
        {t('mapOverlays.protectedUsers')}
      </div>
      {showTrails && (
        <div className={`mfc at ${filters.trails ? 'on' : ''}`} onClick={() => onToggleFilter('trails')}>
          <span className="cd t" />
          {t('mapOverlays.trails')}
        </div>
      )}
    </div>
  );
}

interface MapStatsProps {
  suspectCount: number;
  proximity: number;
  siteCount: number;
  clock: string;
}

function MapStats({ suspectCount, proximity, siteCount, clock }: MapStatsProps) {
  const { t } = useTranslation();
  return (
    <div className="map-stats">
      <div className="msp">
        <span className="mspl">{t('mapOverlays.suspects')}</span>
        <span className="mspv r">{suspectCount}</span>
      </div>
      <div className="msp">
        <span className="mspl">{t('mapOverlays.inProximity')}</span>
        <span className="mspv g">{proximity}</span>
      </div>
      <div className="msp">
        <span className="mspl">{t('mapOverlays.sites')}</span>
        <span className="mspv b">{siteCount}</span>
      </div>
      <div className="msp">
        <span className="mspl">{t('mapOverlays.updated')}</span>
        <span className="mspv gr">{clock}</span>
      </div>
    </div>
  );
}

export { MapControls, MapFilters, MapStats };
